export default "__VITE_ASSET__COEB4wzJ__"